<div
  class="vendor-active-subscription__overlay"
  *ngIf="isVisible"
  (click)="onOverlayClick($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title"
>
  <div class="vendor-active-subscription__container" (click)="$event.stopPropagation()">
    <header class="vendor-active-subscription__header">
      <button
        type="button"
        class="vendor-active-subscription__back"
        *ngIf="showPlanChange"
        (click)="onPlanChangeBack()"
        aria-label="Back to the subscription"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path
            d="M11 4L6 9L11 14"
            stroke="#15172E"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <h2 class="vendor-active-subscription__title">{{ title }}</h2>
      <button
        type="button"
        class="vendor-active-subscription__close"
        (click)="onClose()"
        aria-label="Close"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="#15172E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </header>

    <div class="vendor-active-subscription__body" *ngIf="showDetailBody">
      <div
        class="vendor-active-subscription__alert vendor-active-subscription__alert--success vendor-plan-change__notice"
        *ngIf="planChangeNotice"
        role="status"
      >
        <span class="vendor-plan-change__notice-title">{{ planChangeNotice.title }}</span>
        <span>{{ planChangeNotice.body }}</span>
      </div>
      <div
        class="vendor-active-subscription__alert vendor-active-subscription__alert--success vendor-plan-change__notice"
        *ngIf="cancelNotice"
        role="status"
        data-testid="cancel-notice"
      >
        <span class="vendor-plan-change__notice-title">{{ cancelNotice.title }}</span>
        <span>{{ cancelNotice.body }}</span>
      </div>
      <div class="vendor-active-subscription__history">
        <app-wash-history-panel
          [isLoading]="isLoadingHistory"
          [statusStrip]="data.statusStrip ?? null"
          [banner]="historyBanner"
          [historyExpanded]="historyExpanded"
          [rewashEligibility]="rewashEligibility"
          [membershipRewashEligibility]="membershipRewashEligibility"
          [prepaidRewashEligibility]="prepaidRewashEligibility"
          (historyToggle)="historyToggle.emit()"
          (pageChange)="historyPageChange.emit($event)"
          (pageSizeChange)="historyPageSizeChange.emit($event)"
          (rewashClick)="rewashClick.emit($event)"
        />
      </div>

      <section
        class="vendor-active-subscription__card"
        aria-labelledby="vendor-subscription-details"
      >
        <div class="vendor-active-subscription__card-header">
          <h3 id="vendor-subscription-details" class="vendor-active-subscription__card-title">
            {{ data.packageName }}
          </h3>
          <app-family-tags [isFamily]="isFamilyTag" [isPrimary]="isPrimaryTag"></app-family-tags>
          <!-- CWS-1780: a cancel from this pop-up outranks a pause tag, as on the Customers tab. -->
          <span
            *ngIf="cancelledTagLabel as cancelledLabel; else pauseOrActive"
            class="vendor-active-subscription__status-badge vendor-active-subscription__status-badge--cancelled"
            data-testid="cancelled-tag"
            >{{ cancelledLabel }}</span
          >
          <ng-template #pauseOrActive>
            <span
              *ngIf="pauseTag; else activeBadge"
              class="vendor-active-subscription__status-badge vendor-active-subscription__status-badge--paused"
              data-testid="pause-tag"
              >{{ pauseTagLabel }}</span
            >
          </ng-template>
          <ng-template #activeBadge>
            <span class="vendor-active-subscription__status-badge">Active</span>
            <span
              *ngIf="data.reactivated"
              class="vendor-active-subscription__status-badge"
              data-testid="reactivated-tag"
              >Successfully Reactivated</span
            >
          </ng-template>
        </div>

        <!-- CWS-1426: a scheduled plan change, until its renewal applies it. -->
        <div class="vendor-plan-change__upcoming" *ngIf="planChangeUpcoming">
          <span class="vendor-plan-change__upcoming-chip">Upcoming</span>
          <span class="vendor-plan-change__upcoming-text">{{ planChangeUpcoming }}</span>
        </div>

        <div class="vendor-active-subscription__grid">
          <div class="vendor-active-subscription__field">
            <span class="vendor-active-subscription__label">Customer name</span>
            <span class="vendor-active-subscription__value">{{ data.customerName }}</span>
          </div>
          <div class="vendor-active-subscription__field">
            <span class="vendor-active-subscription__label">Vehicle license plate</span>
            <span class="vendor-active-subscription__value">{{ data.licensePlate }}</span>
          </div>
          <div class="vendor-active-subscription__field">
            <span class="vendor-active-subscription__label">Phone number</span>
            <span class="vendor-active-subscription__value">{{ data.phoneNumber || '—' }}</span>
          </div>
        </div>

        <div class="vendor-active-subscription__divider" role="presentation"></div>

        <div
          class="vendor-active-subscription__stats"
          [class.vendor-active-subscription__stats--four]="!!pauseStatLabel !== !!cardOnFile"
        >
          <div class="vendor-active-subscription__stat">
            <span class="vendor-active-subscription__label">Total washes available</span>
            <span class="vendor-active-subscription__stat-value">{{
              data.totalWashesAvailable
            }}</span>
          </div>
          <div class="vendor-active-subscription__stat" *ngIf="pauseStatLabel">
            <span class="vendor-active-subscription__label">{{ pauseStatLabel }}</span>
            <span class="vendor-active-subscription__stat-value" data-testid="pause-stat">{{
              pauseStatDate
            }}</span>
          </div>
          <div class="vendor-active-subscription__stat">
            <span class="vendor-active-subscription__label">Total washes redeemed</span>
            <span class="vendor-active-subscription__stat-value">{{
              data.totalWashesRedeemed
            }}</span>
          </div>
          <div class="vendor-active-subscription__stat">
            <span class="vendor-active-subscription__label">Last washed date</span>
            <span class="vendor-active-subscription__stat-value">{{ data.lastWashedDate }}</span>
          </div>
          <div class="vendor-active-subscription__stat" *ngIf="cardOnFile">
            <span class="vendor-active-subscription__label">Card on file</span>
            <span class="vendor-active-subscription__stat-value" data-testid="card-on-file">{{
              cardOnFile
            }}</span>
          </div>
        </div>
      </section>

      <ng-container *ngIf="isMembershipLimitReached">
        <div class="vendor-active-subscription__alert" role="alert">
          {{ membershipLimitReachedMessage }}
        </div>
      </ng-container>

      <app-subscription-pause-notice *ngIf="pauseView?.banner" [pause]="pause" />

      <ng-container *ngIf="showMembershipStatusAlert">
        <div
          class="vendor-active-subscription__alert"
          [class.vendor-active-subscription__alert--success]="data.cardDetailsCollected"
          role="alert"
        >
          {{ alertMessage }}
        </div>
      </ng-container>

      <ng-container *ngIf="showPaymentCollection">
        <section class="vendor-active-subscription__payment" aria-labelledby="vendor-add-payment">
          <h3 id="vendor-add-payment" class="vendor-active-subscription__payment-title">
            Add Payment
          </h3>

          <!-- Same Show/Hide summary accordion pattern as payment-checkout -->
          <div class="vendor-active-subscription__summary-toolbar">
            <span
              class="vendor-active-subscription__summary-toggle"
              (click)="togglePaymentSummary()"
              (keydown.enter)="togglePaymentSummary()"
              (keydown.space)="$event.preventDefault(); togglePaymentSummary()"
              tabindex="0"
              role="button"
              [attr.aria-expanded]="showPaymentSummary"
            >
              {{ showPaymentSummary ? 'Hide summary' : 'Show summary' }}
            </span>
          </div>

          <div class="vendor-active-subscription__summary" *ngIf="showPaymentSummary">
            <div class="vendor-active-subscription__summary-card">
              <div class="vendor-active-subscription__summary-title">
                {{ data.packageName || 'Membership package' }}
              </div>
              <div class="vendor-active-subscription__summary-rows">
                <div class="vendor-active-subscription__summary-row">
                  <img
                    src="assets/images/payment-summary/calendar.svg"
                    alt=""
                    class="vendor-active-subscription__summary-icon"
                  />
                  <span>Monthly membership</span>
                </div>
                <div class="vendor-active-subscription__summary-row" *ngIf="data.licensePlate">
                  <img
                    src="assets/images/payment-summary/car.svg"
                    alt=""
                    class="vendor-active-subscription__summary-icon"
                  />
                  <span>{{ data.licensePlate }}</span>
                </div>
                <div class="vendor-active-subscription__summary-row" *ngIf="data.customerName">
                  <span>{{ data.customerName }}</span>
                </div>
              </div>
              <div class="vendor-active-subscription__summary-price">
                <span class="vendor-active-subscription__summary-amount">{{
                  formattedMembershipPrice
                }}</span>
                <span class="vendor-active-subscription__summary-period">/month</span>
              </div>
              <p class="vendor-active-subscription__summary-note">
                Card is saved now. No charge today — billing starts on
                {{ billingStartsLabel }} at {{ formattedMembershipPrice }}/month. Until then the
                imported membership stays valid.
              </p>
            </div>

            <div class="vendor-active-subscription__summary-breakdown">
              <div class="vendor-active-subscription__summary-row">
                <span>Due today</span>
                <span>{{ formattedAmountDueToday }}</span>
              </div>
              <div class="vendor-active-subscription__summary-row">
                <span>Next charge ({{ billingStartsLabel }})</span>
                <span>{{ formattedMembershipPrice }}</span>
              </div>
              <div class="vendor-active-subscription__summary-row">
                <span>Payment method</span>
                <span>{{ selectedPaymentMethodLabel }}</span>
              </div>
              <div
                class="vendor-active-subscription__summary-row"
                *ngIf="selectedPaymentMethod === PaymentMethodCode.Card"
              >
                <span>Card capture</span>
                <span>Enter below</span>
              </div>
              <div
                class="vendor-active-subscription__summary-row"
                *ngIf="selectedPaymentMethod === PaymentMethodCode.Terminal"
              >
                <span>Terminal</span>
                <span>On Confirm</span>
              </div>
              <div
                class="vendor-active-subscription__summary-row"
                *ngIf="selectedPaymentMethod === PaymentMethodCode.Link"
              >
                <span>Payment link</span>
                <span>SMS / link</span>
              </div>
              <div
                class="vendor-active-subscription__summary-row"
                *ngIf="selectedPaymentMethod === PaymentMethodCode.TapToPay"
              >
                <span>Tap to Pay</span>
                <span>On Confirm</span>
              </div>
            </div>

            <div class="vendor-active-subscription__summary-total">
              <span>Due today</span>
              <span>{{ formattedAmountDueToday }}</span>
            </div>
          </div>

          <div
            class="vendor-active-subscription__methods"
            role="radiogroup"
            aria-label="Payment method"
          >
            <button
              type="button"
              class="vendor-active-subscription__method"
              [class.selected]="selectedPaymentMethod === PaymentMethodCode.TapToPay"
              [class.disabled]="!isMethodEnabled(PaymentMethodCode.TapToPay)"
              [disabled]="!isMethodEnabled(PaymentMethodCode.TapToPay)"
              (click)="selectPaymentMethod(PaymentMethodCode.TapToPay)"
            >
              <div class="vendor-active-subscription__method-copy">
                <span class="vendor-active-subscription__method-title">Tap to Pay</span>
                <span class="vendor-active-subscription__method-desc"
                  >Open the app to process payment</span
                >
              </div>
              <span
                class="vendor-active-subscription__radio"
                [class.checked]="selectedPaymentMethod === PaymentMethodCode.TapToPay"
              ></span>
            </button>

            <button
              type="button"
              class="vendor-active-subscription__method"
              [class.selected]="selectedPaymentMethod === PaymentMethodCode.Card"
              [class.disabled]="!isMethodEnabled(PaymentMethodCode.Card)"
              [disabled]="!isMethodEnabled(PaymentMethodCode.Card)"
              (click)="selectPaymentMethod(PaymentMethodCode.Card)"
            >
              <div class="vendor-active-subscription__method-copy">
                <span class="vendor-active-subscription__method-title">Card Payment</span>
                <span class="vendor-active-subscription__method-desc"
                  >Save card now — billed at membership expiry</span
                >
              </div>
              <span
                class="vendor-active-subscription__radio"
                [class.checked]="selectedPaymentMethod === PaymentMethodCode.Card"
              ></span>
            </button>

            <button
              *ngIf="isMethodVisible(PaymentMethodCode.Terminal)"
              type="button"
              class="vendor-active-subscription__method"
              [class.selected]="selectedPaymentMethod === PaymentMethodCode.Terminal"
              [class.disabled]="!isMethodEnabled(PaymentMethodCode.Terminal)"
              [disabled]="!isMethodEnabled(PaymentMethodCode.Terminal)"
              (click)="selectPaymentMethod(PaymentMethodCode.Terminal)"
            >
              <div class="vendor-active-subscription__method-copy">
                <span class="vendor-active-subscription__method-title">Terminal payment</span>
                <span class="vendor-active-subscription__method-desc"
                  >Open the app to process payment</span
                >
              </div>
              <span
                class="vendor-active-subscription__radio"
                [class.checked]="selectedPaymentMethod === PaymentMethodCode.Terminal"
              ></span>
            </button>

            <button
              type="button"
              class="vendor-active-subscription__method"
              [class.selected]="selectedPaymentMethod === PaymentMethodCode.Link"
              [class.disabled]="!isMethodEnabled(PaymentMethodCode.Link)"
              [disabled]="!isMethodEnabled(PaymentMethodCode.Link)"
              (click)="selectPaymentMethod(PaymentMethodCode.Link)"
            >
              <div class="vendor-active-subscription__method-copy">
                <span class="vendor-active-subscription__method-title">Send payment link</span>
                <span class="vendor-active-subscription__method-desc"
                  >Enter card details to make payment</span
                >
              </div>
              <span
                class="vendor-active-subscription__radio"
                [class.checked]="selectedPaymentMethod === PaymentMethodCode.Link"
              ></span>
            </button>
          </div>

          <!-- Inline Stripe card form (same fields / IDs as payment-checkout) -->
          <div
            *ngIf="showInlineCardForm"
            class="vendor-active-subscription__card-form"
            data-fs-mask
          >
            <div class="vendor-active-subscription__stripe-form">
              <div class="vendor-active-subscription__form-row">
                <div class="vendor-active-subscription__form-field">
                  <label class="vendor-active-subscription__field-label"
                    >Name on card<span class="asterisk">*</span></label
                  >
                  <div class="vendor-active-subscription__stripe-input">
                    <input
                      type="text"
                      class="vendor-active-subscription__stripe-field"
                      placeholder="e.g. John Smith"
                      autocomplete="cc-name"
                      [ngModel]="cardholderName"
                      (ngModelChange)="onCardholderNameInput($event)"
                      name="vendorCardholderName"
                    />
                  </div>
                </div>
                <div class="vendor-active-subscription__form-field">
                  <label class="vendor-active-subscription__field-label"
                    >Card number<span class="asterisk">*</span></label
                  >
                  <div class="vendor-active-subscription__stripe-input">
                    <div
                      id="vendor-active-card-number"
                      class="vendor-active-subscription__stripe-field"
                    ></div>
                  </div>
                  <div
                    id="vendor-active-card-number-error"
                    class="vendor-active-subscription__field-error"
                    role="alert"
                  ></div>
                </div>
              </div>

              <div class="vendor-active-subscription__form-row">
                <div class="vendor-active-subscription__form-field">
                  <label class="vendor-active-subscription__field-label"
                    >Expiration<span class="asterisk">*</span></label
                  >
                  <div class="vendor-active-subscription__stripe-input">
                    <div
                      id="vendor-active-card-expiry"
                      class="vendor-active-subscription__stripe-field"
                    ></div>
                  </div>
                  <div
                    id="vendor-active-card-expiry-error"
                    class="vendor-active-subscription__field-error"
                    role="alert"
                  ></div>
                </div>
                <div class="vendor-active-subscription__form-field">
                  <label class="vendor-active-subscription__field-label"
                    >CVC<span class="asterisk">*</span></label
                  >
                  <div class="vendor-active-subscription__stripe-input">
                    <div
                      id="vendor-active-card-cvc"
                      class="vendor-active-subscription__stripe-field"
                    ></div>
                  </div>
                  <div
                    id="vendor-active-card-cvc-error"
                    class="vendor-active-subscription__field-error"
                    role="alert"
                  ></div>
                </div>
              </div>

              <div class="vendor-active-subscription__form-field">
                <label class="vendor-active-subscription__field-label">Billing address</label>
                <div class="vendor-active-subscription__stripe-input">
                  <input
                    type="text"
                    class="vendor-active-subscription__stripe-field"
                    placeholder="e.g. 122B, Baker Street, NYC"
                    [ngModel]="billingAddress"
                    (ngModelChange)="onBillingAddressInput($event)"
                    name="vendorBillingAddress"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="vendor-active-subscription__fields">
            <div
              class="vendor-active-subscription__field-input vendor-active-subscription__field-input--phone"
            >
              <app-custom-input
                label="Phone number"
                placeholder="e.g. (212) 555-1234"
                type="tel"
                inputMode="numeric"
                [required]="isPaymentLinkPhoneRequired"
                [validationRules]="phoneValidationRules"
                [showValidation]="true"
                [markTouchedOnInput]="true"
                [(value)]="phoneNumber"
              ></app-custom-input>
            </div>
          </div>

          <div class="vendor-active-subscription__payment-actions">
            <button
              type="button"
              class="vendor-active-subscription__secondary"
              (click)="onUpgradePlan()"
            >
              Upgrade plan
            </button>
            <button
              type="button"
              class="vendor-active-subscription__confirm"
              [disabled]="!canConfirmPayment"
              (click)="onConfirmPayment()"
            >
              Confirm Payment
            </button>
          </div>
        </section>
      </ng-container>
    </div>

    <div class="vendor-active-subscription__body" *ngIf="showPlanChange">
      <app-plan-change-panel
        [subscriptionId]="data.subscriptionId"
        [locationId]="planChangeLocationId"
        [isActive]="showPlanChange"
        (back)="onPlanChangeBack()"
        (applied)="onPlanChangeApplied($event)"
      />
    </div>

    <div class="vendor-active-subscription__body" *ngIf="showUpgradePlanPicker">
      <p class="vendor-upgrade-plan__loading" *ngIf="isLoadingUpgradePlans">Loading packages…</p>
      <ng-container *ngIf="!isLoadingUpgradePlans">
        <section class="vendor-upgrade-plan__section" *ngIf="upgradePlans.length > 0">
          <h3 class="vendor-upgrade-plan__label">Monthly Wash</h3>
          <div class="vendor-upgrade-plan__grid">
            <button
              type="button"
              class="vendor-upgrade-plan__card"
              *ngFor="let plan of upgradePlans"
              [class.vendor-upgrade-plan__card--selected]="isUpgradePlanSelected(plan)"
              [class.vendor-upgrade-plan__card--themed]="!!plan.themeColor"
              (click)="selectUpgradePlan(plan)"
            >
              <span
                *ngIf="plan.themeColor as themeColor"
                class="vendor-upgrade-plan__theme"
                [style.background]="themeColor"
                aria-hidden="true"
              ></span>
              <span class="vendor-upgrade-plan__name">{{ plan.displayName }}</span>
              <span class="vendor-upgrade-plan__price">{{ plan.priceLabel }}</span>
            </button>
          </div>
        </section>
        <p class="vendor-upgrade-plan__empty" *ngIf="upgradePlans.length === 0">
          No monthly wash packages are available for this location.
        </p>

        <section class="vendor-upgrade-plan__section" *ngIf="upgradeDiscounts.length > 0">
          <h3 class="vendor-upgrade-plan__label">Discounts</h3>
          <div class="vendor-upgrade-plan__grid">
            <button
              type="button"
              class="vendor-upgrade-plan__card vendor-upgrade-plan__card--discount"
              *ngFor="let discount of upgradeDiscounts"
              [class.vendor-upgrade-plan__card--selected]="isUpgradeDiscountSelected(discount)"
              (click)="selectUpgradeDiscount(discount)"
            >
              <span class="vendor-upgrade-plan__name">{{ discount.label }}</span>
              <span class="vendor-upgrade-plan__price" *ngIf="discount.mode === 'fixed'">{{
                discount.priceLabel
              }}</span>
              <span class="vendor-upgrade-plan__custom" *ngIf="discount.mode === 'custom'">
                Custom Price
              </span>
            </button>
          </div>
        </section>
      </ng-container>
    </div>

    <footer class="vendor-active-subscription__footer" *ngIf="showDetailBody">
      <p *ngIf="errorMessage" class="vendor-active-subscription__error" role="alert">
        {{ errorMessage }}
      </p>
      <div class="vendor-active-subscription__footer-row">
        <!-- CWS-1426 / CWS-1547 / CWS-1536 / CWS-1780: Manage Subscription menu (Update opens the plan-change state). -->
        <app-manage-subscription-menu
          *ngIf="showManageMenu; else footerSpacer"
          [showUpdate]="pauseView ? pauseView.manage.updateVisible : canChangePlan"
          [showPause]="pauseView ? pauseView.manage.pauseVisible : false"
          [showCancelScheduled]="pauseView?.manage?.showCancelScheduled ?? false"
          [showCancel]="showCancelItem"
          (update)="onManageUpdate()"
          (pause)="onManagePause()"
          (cancelScheduledPause)="onManageCancelScheduledPause()"
          (cancelMembership)="onManageCancel()"
          [showPaymentMethod]="showPaymentMethod"
          (paymentMethod)="onManagePaymentMethod()"
          [showStartFamily]="showStartFamilyItem"
          (startFamily)="onManageStartFamily()"
        />
        <ng-template #footerSpacer><span></span></ng-template>
        <button
          *ngIf="showActivate"
          type="button"
          class="btn btn-primary-green btn-large"
          data-testid="activate-now"
          [disabled]="pauseFlow.busy"
          (click)="onActivateNow()"
        >
          {{ pauseFlow.busy ? 'Activating...' : 'Activate now' }}
        </button>
        <button
          *ngIf="!hidePrimary"
          type="button"
          class="vendor-active-subscription__primary"
          [disabled]="isPrimaryActionDisabled"
          (click)="onPrimaryAction()"
        >
          {{ primaryButtonLabel }}
        </button>
      </div>
    </footer>
    <footer
      class="vendor-active-subscription__footer vendor-upgrade-plan__footer"
      *ngIf="showUpgradePlanPicker"
    >
      <button
        type="button"
        class="vendor-active-subscription__secondary"
        (click)="onUpgradePlanBack()"
      >
        Back
      </button>
      <button
        type="button"
        class="vendor-active-subscription__primary"
        [disabled]="!canConfirmUpgradePlan || isLoadingUpgradePlans"
        (click)="onUpgradePlanConfirm()"
      >
        Confirmation
      </button>
    </footer>
  </div>
</div>

<!--
  CWS-1780: the shared cancel & refund panel (CWS-1778), keyed by the membership. It sits outside
  the pop-up's overlay like the pause modals, so it needs its own z-index above it (see scss).
-->
<app-cancel-refund-panel
  *ngIf="showCancelPanel"
  [isOpen]="true"
  [subscriptionId]="data.subscriptionId"
  [locationId]="planChangeLocationId"
  intent="cancel"
  [customerName]="data.customerName"
  (closed)="closeCancelPanel()"
  (done)="onCancelDone($event)"
/>

<app-pause-subscription-modal
  [visible]="!!pauseFlow.pauseTarget"
  [periodEnd]="pauseFlow.pauseTarget?.periodEnd ?? null"
  [timeZone]="pauseFlow.pauseTarget?.timeZone ?? null"
  [busy]="pauseFlow.busy"
  [errorCode]="pauseFlow.errorCode"
  (selectionChange)="pauseFlow.clearError()"
  (confirm)="pauseFlow.confirmPause($event)"
  (cancel)="pauseFlow.closePause()"
/>

<app-confirm-action-modal
  *ngIf="pauseFlow.cancelTarget"
  title="Cancel scheduled pause?"
  message="The membership will stay active and keep billing as normal."
  confirmLabel="Cancel pause"
  cancelLabel="Keep pause"
  busyLabel="Cancelling..."
  [busy]="pauseFlow.busy"
  testId="cancel-scheduled-pause-modal"
  style="--confirm-modal-overlay-z: 13000"
  (confirm)="pauseFlow.confirmCancelScheduled()"
  (cancel)="pauseFlow.dismissCancelScheduled()"
>
  <p class="vendor-active-subscription__error" *ngIf="flowError" role="alert">{{ flowError }}</p>
</app-confirm-action-modal>

<app-confirm-action-modal
  *ngIf="pauseFlow.activateTarget"
  title="Activate now?"
  [message]="activateMessage"
  confirmLabel="Activate now"
  busyLabel="Activating..."
  [busy]="pauseFlow.busy"
  testId="activate-now-modal"
  style="--confirm-modal-overlay-z: 13000"
  (confirm)="pauseFlow.confirmActivate()"
  (cancel)="pauseFlow.dismissActivate()"
>
  <p class="vendor-active-subscription__error" *ngIf="flowError" role="alert">{{ flowError }}</p>
</app-confirm-action-modal>

<app-subscription-result-modal
  [visible]="!!pauseFlow.result"
  [header]="pauseFlow.result?.header ?? ''"
  [title]="pauseFlow.result?.title ?? ''"
  [message]="pauseFlow.result?.message ?? ''"
  (close)="pauseFlow.closeResult()"
/>

<!-- CWS-1581: Start Family pop-up and its result, over this one. -->
<app-start-family-modal
  [target]="startFamilyFlow.target"
  [preview]="startFamilyFlow.preview"
  [loading]="startFamilyFlow.loading"
  [busy]="startFamilyFlow.busy"
  [reason]="startFamilyFlow.reason"
  (confirm)="startFamilyFlow.confirm()"
  (cancel)="startFamilyFlow.close()"
/>

<app-family-members-modal [flow]="membersFlow" />

<!-- CWS-1536: the Subscriptions tab's Payment method pop-up, over this one. -->
<app-payment-method-modal
  *ngIf="paymentMethodSubject as subject"
  [subject]="subject"
  (updated)="onPaymentMethodUpdated($event)"
  (closed)="closePaymentMethod()"
/>
